import { getRequest } from '../utils'

export const getProjectFiles: RequestTypeVariable = {
  getKey: (projectId: string, rootGuid: string) => ['getProjectFiles', projectId, rootGuid],
  request: async (
    projectId: string,
    rootGuid: string,
  ): Promise<{ [key: string]: FilesResult } | null> => {
    const { data } = await getRequest<{ [key: string]: FilesResult }>({
      url: `projects/${projectId}/files/${rootGuid}`,
    })

    return data
  },
}

export const getProjectFile: RequestTypeVariable = {
  getKey: (projectId: string, rootGuid: string, fileGuid: string) => [
    'getProjectFile',
    projectId,
    rootGuid,
    fileGuid,
  ],
  request: async (projectId: string, rootGuid: string, fileGuid: string): Promise<FileItem> => {
    const { data } = await getRequest<FileItem>({
      url: `projects/${projectId}/files/${rootGuid}/file/${fileGuid}`,
    })

    return data as FileItem
  },
}

export const getProjectFilesTemplates: RequestTypeVariable = {
  getKey: (projectId: string, documentationRootGuid: string) => [
    'getProjectFilesTemplates',
    projectId,
    documentationRootGuid,
  ],
  request: async (
    projectId: string,
    documentationRootGuid: string,
  ): Promise<Record<string, TemplatesResult>> => {
    const { data } = await getRequest<Record<string, TemplatesResult>>({
      url: `projects/${projectId}/files/${documentationRootGuid}/templates`,
    })

    return data as Record<string, TemplatesResult>
  },
}
